import { Button, Table } from "react-bootstrap";
import ExportHalfYearlyPDF from "../../utility/ExportHalfYearlyPdf";
import { useEffect, useState } from "react";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/AuthFetch";

function HalfYearly({
  student,
  standardLabel,
  divisionLabel,
  marksData,
  maxMarksData,
  finYearLabel,
  total,
  setLoader,
  finYear,
}) {
  const [criteriaResult, setCriteriaResult] = useState([]);

  useEffect(() => {
    const fetchCriteria = async () => {
      setLoader(true);
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/criteria-result?student=${student.admission}&type='half-yearly'&finYear=${finYear}`,
        );
        const result = await response.json();
        setCriteriaResult(result.result);
      } catch (error) {
        console.error("Error fetching Criteria results:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchCriteria();
  }, [student]);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Button
          variant="success"
          className="mb-3"
          onClick={() =>
            ExportHalfYearlyPDF({
              student,
              standardLabel,
              divisionLabel,
              marksData,
              maxMarksData,
              finYearLabel,
              criteriaResult,
            })
          }
        >
          Export PDF
        </Button>
      </div>
      <Table striped bordered hover id="marksTable">
        <thead>
          <tr>
            <th rowSpan={2} style={{ verticalAlign: "middle" }}>
              SUBJECT
            </th>
            <th colSpan={2}></th>
            <th colSpan={5} style={{ textAlign: "center" }}>
              INTERNAL ASSESSMENT
            </th>
            <th colSpan={3} style={{ textAlign: "center" }}>
              HALF YEARLY EXAM
            </th>
          </tr>
          <tr>
            <th>PT 1</th>
            <th>PT 2</th>
            <th>CLASS WORK</th>
            <th>HOME WORK</th>
            <th>SUB ENRICHMENT</th>
            <th>DISCIPLINE</th>
            <th>CLASS INVOLVEMENT</th>
            <th>THEORY</th>
            <th>Marks Obtained</th>
            <th>GRADE</th>
          </tr>
          <tr>
            <th></th>
            <th>{maxMarksData.PT1}</th>
            <th>{maxMarksData.PT2}</th>
            <th>{maxMarksData.IA / 5}</th>
            <th>{maxMarksData.IA / 5}</th>
            <th>{maxMarksData.IA / 5}</th>
            <th>{maxMarksData.IA / 5}</th>
            <th>{maxMarksData.IA / 5}</th>
            <th>{maxMarksData.HY}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {marksData.map((row, idx) => (
            <tr key={idx}>
              <td>{row.subjectName}</td>
              <td>{row.pt1Remarks === "AB" ? "AB" : row.pt1}</td>
              <td>{row.pt2Remarks === "AB" ? "AB" : row.pt2}</td>
              <td>{row.iaRemarks === "AB" ? "AB" : row.classWork}</td>
              <td>{row.iaRemarks === "AB" ? "AB" : row.homeWork}</td>
              <td>{row.iaRemarks === "AB" ? "AB" : row.subEnrichment}</td>
              <td>{row.iaRemarks === "AB" ? "AB" : row.discipline}</td>
              <td>{row.iaRemarks === "AB" ? "AB" : row.classInvolvement}</td>
              <th>{maxMarksData.HY}</th>
              <td>{row.hyRemarks === "AB" ? "AB" : row.halfYearly}</td>
              <td>{row.grade}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={9} className="text-end">
              Total
            </td>
            <td>{total}</td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={9} className="text-end">
              Percentage
            </td>
            <td>
              {((total / (marksData.length * maxMarksData.HY)) * 100).toFixed(
                2,
              )}
              %
            </td>

            <td></td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}

export default HalfYearly;
